package pt.at.oss.kotlin.manual.schema.common

import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.ISSUING_COUNTRY_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.TAX_REF_NUM_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.VAT_ID_NUMBER_MAX_LEN
import pt.at.oss.kotlin.manual.storage.common.VatId
import pt.lightweightform.kotlin.schema.RecordSchema
import pt.lightweightform.kotlin.schema.StringSchema
import pt.lightweightform.kotlin.type.validator.ValidationErrors
import pt.lightweightform.kotlin.util.appendToPath

/**
 * CurrVatIdSchema Schema object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
class VatIdSchema(name: String, isRequired: Boolean) : RecordSchema<VatId>(name = name, isRequired = isRequired) {

    val schemeSchema: StringSchema = StringSchema(name = "scheme", isRequired = false)
    val issuingCountrySchema: StringSchema = StringSchema(name = "issuingCountry", isRequired = isRequired, minLength = ISSUING_COUNTRY_LEN, maxLength = ISSUING_COUNTRY_LEN)
    val vatIdNumSchema: StringSchema = StringSchema(name = "vatIdNum", maxLength = VAT_ID_NUMBER_MAX_LEN)
    val taxRefNumSchema: StringSchema = StringSchema(name = "taxRefNum", maxLength = TAX_REF_NUM_MAX_LEN)
    override fun isValid(value: VatId?): Boolean {
        return value == null || (
            issuingCountrySchema.isValid(value.issuingCountry) &&
                schemeSchema.isValid(value.scheme) &&
                vatIdNumSchema.isValid(value.vatIdNum) &&
                taxRefNumSchema.isValid(value.taxRefNum)
            )
    }

    override fun validate(value: VatId?, path: String): ValidationErrors {
        val validator = super.validate(value, path)
        if (value === null) {
            return validator
        }
        validator.addErrors(schemeSchema.validate(value.scheme, appendToPath(path, "scheme")))
        validator.addErrors(issuingCountrySchema.validate(value.issuingCountry, appendToPath(path, "issuingCountry")))
        validator.addErrors(vatIdNumSchema.validate(value.vatIdNum, appendToPath(path, "vatIdNum")))
        validator.addErrors(taxRefNumSchema.validate(value.taxRefNum, appendToPath(path, "taxRefNum")))
        return validator
    }
}
